import script from "./FamilyNav.vue?vue&type=script&setup=true&lang=js"
export * from "./FamilyNav.vue?vue&type=script&setup=true&lang=js"

import "./FamilyNav.vue?vue&type=style&index=0&id=0ceb7af5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ceb7af5"]])

export default __exports__